import type { LucideIcon } from 'lucide-react';

type StatusCardProps = {
  icon: LucideIcon;
  label: string;
  value: string;
  tone?: 'neutral' | 'success' | 'warning' | 'danger';
};

export function StatusCard({ icon: Icon, label, value, tone = 'neutral' }: StatusCardProps) {
  return (
    <article className={`status-card ${tone}`}>
      <Icon size={19} aria-hidden="true" />
      <div>
        <p>{label}</p>
        <strong>{value}</strong>
      </div>
    </article>
  );
}
